import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TActivatePrpRequest,
	TGetPrpPostalOperatorSettingsRequest,
	TPrpEmIdRequest,
	TPrpPostalOperatorSettingsListResponse,
	TPrpSettings,
	TPrpStore,
	TUpdatePrpPostalOperatorSettingsRequest,
	TUpdatePrpSettingsRequest,
} from './types';

// ==========================================:
export const initialState: TPrpStore = {
	settings: null,
	settingsLoading: false,
	settingsSaveLoading: false,
	settingsSaveSuccess: false,

	postalOperatorSettingsList: null,
	postalOperatorSettingsListLoading: false,
	postalOperatorSettingsLastListParams: null,
	postalOperatorSettingsSaveLoading: false,
	postalOperatorSettingsSaveSuccess: false,
};

// ==========================================:
const prpSlice = createSlice({
	name: '@@prp',
	initialState,
	reducers: {
		// ============ Settings ============
		getPrpSettingsRequest: (state, _action: PayloadAction<TPrpEmIdRequest>) => {
			state.settingsLoading = true;
		},
		getPrpSettingsSuccess: (state, action: PayloadAction<TPrpSettings>) => {
			state.settings = action.payload;
			state.settingsLoading = false;
		},
		getPrpSettingsFailure: (state) => {
			state.settingsLoading = false;
		},
		clearPrpSettings: (state) => {
			state.settings = null;
		},

		updatePrpSettingsRequest: (state, _action: PayloadAction<TUpdatePrpSettingsRequest>) => {
			state.settingsSaveLoading = true;
			state.settingsSaveSuccess = false;
		},
		activatePrpRequest: (state, _action: PayloadAction<TActivatePrpRequest>) => {
			state.settingsSaveLoading = true;
			state.settingsSaveSuccess = false;
		},
		savePrpSettingsSuccess: (state) => {
			state.settingsSaveLoading = false;
			state.settingsSaveSuccess = true;
		},
		savePrpSettingsFailure: (state) => {
			state.settingsSaveLoading = false;
		},
		resetPrpSettingsSaveSuccess: (state) => {
			state.settingsSaveSuccess = false;
		},

		// ============ Postal operator settings ============
		getPrpPostalOperatorSettingsRequest: (
			state,
			action: PayloadAction<TGetPrpPostalOperatorSettingsRequest>,
		) => {
			state.postalOperatorSettingsListLoading = true;
			state.postalOperatorSettingsLastListParams = action.payload;
		},
		getPrpPostalOperatorSettingsSuccess: (
			state,
			action: PayloadAction<TPrpPostalOperatorSettingsListResponse>,
		) => {
			state.postalOperatorSettingsList = action.payload;
			state.postalOperatorSettingsListLoading = false;
		},
		getPrpPostalOperatorSettingsFailure: (state) => {
			state.postalOperatorSettingsListLoading = false;
		},
		clearPrpPostalOperatorSettings: (state) => {
			state.postalOperatorSettingsList = null;
			state.postalOperatorSettingsLastListParams = null;
		},

		updatePrpPostalOperatorSettingsRequest: (
			state,
			_action: PayloadAction<TUpdatePrpPostalOperatorSettingsRequest>,
		) => {
			state.postalOperatorSettingsSaveLoading = true;
			state.postalOperatorSettingsSaveSuccess = false;
		},
		savePrpPostalOperatorSettingsSuccess: (state) => {
			state.postalOperatorSettingsSaveLoading = false;
			state.postalOperatorSettingsSaveSuccess = true;
		},
		savePrpPostalOperatorSettingsFailure: (state) => {
			state.postalOperatorSettingsSaveLoading = false;
		},
		resetPrpPostalOperatorSettingsSaveSuccess: (state) => {
			state.postalOperatorSettingsSaveSuccess = false;
		},

		prpInitState: () => initialState,
	},
});

export default prpSlice.reducer;
export const {
	getPrpSettingsRequest,
	getPrpSettingsSuccess,
	getPrpSettingsFailure,
	clearPrpSettings,
	updatePrpSettingsRequest,
	activatePrpRequest,
	savePrpSettingsSuccess,
	savePrpSettingsFailure,
	resetPrpSettingsSaveSuccess,
	getPrpPostalOperatorSettingsRequest,
	getPrpPostalOperatorSettingsSuccess,
	getPrpPostalOperatorSettingsFailure,
	clearPrpPostalOperatorSettings,
	updatePrpPostalOperatorSettingsRequest,
	savePrpPostalOperatorSettingsSuccess,
	savePrpPostalOperatorSettingsFailure,
	resetPrpPostalOperatorSettingsSaveSuccess,
	prpInitState,
} = prpSlice.actions;
